module.exports = __webpack_public_path__ + "media/images/home_image-f6c01c076b9a7a505cfb0f015b66fe31.jpg";